import React from 'react';

import { createStyles, Paper, Theme, Toolbar, withStyles, WithStyles } from '@material-ui/core';
import { PaperProps } from '@material-ui/core/Paper';
import { ToolbarProps } from '@material-ui/core/Toolbar';

const filtersWidth = 236;

const styles = ({
  spacing: { unit },
  palette: {
    common: { white },
  },
}: Theme) =>
  createStyles({
    toolbar: {
      background: white,
    },
    content: {
      display: 'flex',
      flex: 1,
      overflow: 'hidden',
      padding: `${unit * 2}px ${unit * 3}px`,
    },
    listContainer: {
      width: '100%',
      overflowX: 'auto',
      marginRight: 0,
    },
    filters: {
      width: filtersWidth,
      minWidth: filtersWidth,
      marginLeft: unit * 2,
    },
    gap: {
      width: unit * 2,
    },
  });

export interface BoxContentWithFiltersProps extends WithStyles<typeof styles> {
  toolbarContent: ToolbarProps['children'];
  content: PaperProps['children'];
  filters?: React.ReactElement;
  filtersVisible?: boolean;
}

const BoxContentWithFilters: React.FC<BoxContentWithFiltersProps> = ({
  classes,
  toolbarContent,
  content,
  filters,
  filtersVisible,
}) => (
  <>
    <Toolbar className={classes.toolbar}>{toolbarContent}</Toolbar>
    <div className={classes.content}>
      <Paper className={classes.listContainer} elevation={0} square>
        {content}
      </Paper>
      {filtersVisible && filters && (
        <Paper className={classes.filters} elevation={0} square>
          {filters}
        </Paper>
      )}
    </div>
  </>
);

export default withStyles(styles)(BoxContentWithFilters);
